module.exports = __webpack_public_path__ + "img/1532264306.d7ee988f.jpg";